import { render } from "./addModuleBaobeiOrderDetail.vue?vue&type=template&id=7d91d922&scoped=true"
import script from "./addModuleBaobeiOrderDetail.vue?vue&type=script&lang=js"
export * from "./addModuleBaobeiOrderDetail.vue?vue&type=script&lang=js"

import "./addModuleBaobeiOrderDetail.vue?vue&type=style&index=0&id=7d91d922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d91d922"]])

export default __exports__